document.addEventListener('DOMContentLoaded', function () {
  const videoList = document.querySelectorAll('video');

  if (videoList && videoList.length > 0) {
    videoList.forEach((video) => {
      video.setAttribute("controlslist", "nodownload");

      /* Standard syntax */
      document.addEventListener("fullscreenchange", function () {
        if (document.fullscreenElement) {
          video.style.mixBlendMode = "initial";
          return;
        }
        video.style.mixBlendMode = "multiply";
      });

      /* Firefox syntax */
      document.addEventListener("mozfullscreenchange", function () {
        if (document.mozFullScreenElement) {
          video.style.mixBlendMode = "initial";
          return;
        }
        video.style.mixBlendMode = "multiply";
      });

      /* Chrome, Safari and Opera syntax */
      document.addEventListener("webkitfullscreenchange", function () {
        if (document.webkitFullscreenElement) {
          video.style.mixBlendMode = "initial";
          return;
        }
        video.style.mixBlendMode = "multiply";
      });
    });
  }

  // Doofinder intervention- not used
  // const hashid = "1590f27a98250cb5dd78b19ac2742657";
  // const hashidShop = "8ccff0e5b802b30b96193e4a1d2b5eea";

  // function waitForDoofinder() {

  //     var doofinder_script ='//cdn.doofinder.com/media/js/doofinder-embedded.7.latest.min.js';
  //     (function(d,t){var f=d.createElement(t),s=d.getElementsByTagName(t)[0];f.async=1;
  //       f.src=('https:'==location.protocol?'https:':'http:')+doofinder_script;
  //       f.setAttribute('charset','utf-8');
  //       s.parentNode.insertBefore(f,s)}(document,'script')
  //     );
  //     var dfEmbeddedLayers = [{
  //       "queryInput": "#input-sections--22689063633174__footer--contactemail",
  //       "hashid": '8ccff0e5b802b30b96193e4a1d2b5eea',
  //       "zone": "eu1",
  //       "display": {
  //         "lang": 'en'
  //       }
  //     }];

  //     /*var doofinder_script ='//cdn.doofinder.com/media/js/doofinder-classic.7.latest.min.js';
  //     var requirejs = "//cdnjs.cloudflare.com/ajax/libs/require.js/2.3.7/require.min.js";

  //     (function(d,t){var f=d.createElement(t),s=d.getElementsByTagName(t)[0];f.async=1;
  //       f.src=('https:'==location.protocol?'https:':'http:')+doofinder_script;
  //       f.setAttribute('charset','utf-8');
  //       s.parentNode.insertBefore(f,s)}(document,'script')
  //     );
  //     (function(d,t){var f=d.createElement(t),s=d.getElementsByTagName(t)[0];f.async=1;
  //       f.src=('https:'==location.protocol?'https:':'http:')+requirejs;
  //       f.setAttribute('charset','utf-8');
  //       s.parentNode.insertBefore(f,s)}(document,'script')
  //     );
  //     var dfClassicLayers = [{
  //       "queryInput": '#q',
  //       "hashid": '8ccff0e5b802b30b96193e4a1d2b5eea',
  //       "zone": "eu1",
  //       "display": {
  //         "lang": 'en'
  //       },
  //       callbacks: {
  //         resultsReceived: function(response) {
  //           console.log("result reveived doofinder!!!", response);
  //         }
  //       },

  //     }];
  //     */

  //     console.log("doofinderlayer installed?", dfEmbeddedLayers[0]);
  // }
  // try {
  //   waitForDoofinder();
  // } catch (error) {
  //   console.log("error when customizing doofinder script");
  //   console.log("error doofinder", error)
  // }
});

/*
------------------------------------------------------------------------------------------------------------------------
Linstan: boost the main header search bar so it also recognizes reservoir references (Geberit/Siamp/Grohe), not just
products/brands. Reuses the same reference -> collection map already loaded for the dedicated reference-lookup page
(window.linstanReferencesData, see snippets/linstan-references-data.liquid and assets/linstan-references-data.js).

This works by patching the theme's native <predictive-search> component (defined in assets/theme.js) after it loads:
once the native search request finishes and the results are rendered, we insert a small "reservoir found" block
above the normal results, linking straight to the matching maintenance collection.
------------------------------------------------------------------------------------------------------------------------
*/
(function () {
  function linstanFindReferenceMatches(query) {
    if (!window.linstanReferencesData || !window.linstanReferencesData.data) {
      return [];
    }
    const q = (query || "").toLowerCase().trim();
    if (q.length < 9) {
      return [];
    }
    const matches = [];
    window.linstanReferencesData.data.forEach((group) => {
      const matchedRefs = (group.references || []).filter((reference) => {
        const ref = reference.toLowerCase();
        const refWithSpace = ref.replaceAll(".", " ");
        const refWithoutDots = ref.replaceAll(".", "");
        return ref.includes(q) || refWithSpace.includes(q) || refWithoutDots.includes(q);
      });
      if (matchedRefs.length > 0) {
        matches.push({ url: group.url, references: matchedRefs });
      }
    });
    return matches;
  }

  function linstanBuildReferenceMatchBlock(query) {
    const matches = linstanFindReferenceMatches(query);
    if (matches.length === 0) {
      return null;
    }

    const wrapper = document.createElement("div");
    wrapper.className = "predictive-search__linstan-reference-match v-stack gap-3";

    const heading = document.createElement("p");
    heading.className = "bold text-subdued";
    heading.textContent = "Réservoirs correspondant à cette référence";
    wrapper.appendChild(heading);

    const list = document.createElement("div");
    list.className = "v-stack gap-3";

    matches.forEach((match) => {
      match.references.forEach((reference) => {
        const link = document.createElement("a");
        link.setAttribute("href", match.url);
        link.setAttribute("data-instant", "");
        link.className = "predictive-search-result group";
        link.innerHTML = `
          <div class="v-stack gap-1 sm:gap-1.5">
            <span class="pk-reference-message"><span data-reference>Réf. ${reference}</span></span>
            <span class="bold"><span class="reversed-link">Voir les pièces compatibles</span></span>
          </div>
        `;
        list.appendChild(link);
      });
    });

    wrapper.appendChild(list);
    return wrapper;
  }

  function linstanFindSkuMatches(query) {
    if (!window.linstanSkuData || !window.linstanSkuData.data) {
      return [];
    }
    const q = (query || "").toLowerCase().trim();
    if (q.length < 3) {
      return [];
    }
    const exact = [];
    const partial = [];
    window.linstanSkuData.data.forEach((entry) => {
      const sku = (entry.sku || "").toLowerCase();
      if (!sku) {
        return;
      }
      if (sku === q) {
        exact.push(entry);
      } else if (sku.includes(q)) {
        partial.push(entry);
      }
    });
    return exact.concat(partial).slice(0, 5);
  }

  function linstanBuildSkuMatchBlock(query) {
    const matches = linstanFindSkuMatches(query);
    if (matches.length === 0) {
      return null;
    }

    const wrapper = document.createElement("div");
    wrapper.className = "predictive-search__linstan-reference-match v-stack gap-3";

    const heading = document.createElement("p");
    heading.className = "bold text-subdued";
    heading.textContent = "Produits correspondant à ce SKU";
    wrapper.appendChild(heading);

    const list = document.createElement("div");
    list.className = "v-stack gap-3";

    matches.forEach((entry) => {
      const link = document.createElement("a");
      link.setAttribute("href", entry.url);
      link.setAttribute("data-instant", "");
      link.className = "predictive-search-result group";

      const stack = document.createElement("div");
      stack.className = "v-stack gap-1 sm:gap-1.5";

      const skuLine = document.createElement("span");
      skuLine.className = "pk-reference-message";
      const skuSpan = document.createElement("span");
      skuSpan.setAttribute("data-reference", "");
      skuSpan.textContent = "SKU " + entry.sku;
      skuLine.appendChild(skuSpan);
      stack.appendChild(skuLine);

      const titleLine = document.createElement("span");
      titleLine.className = "bold";
      titleLine.textContent = entry.title || "";
      stack.appendChild(titleLine);

      link.appendChild(stack);
      list.appendChild(link);
    });

    wrapper.appendChild(list);
    return wrapper;
  }

  function linstanInjectReferenceMatch(predictiveSearchEl) {
    if (!predictiveSearchEl || !predictiveSearchEl._queryInput) {
      return;
    }
    const resultsSlotEl = predictiveSearchEl.querySelector('[slot="results"]');
    if (!resultsSlotEl) {
      return;
    }
    const query = predictiveSearchEl._queryInput.value;
    const referenceBlock = linstanBuildReferenceMatchBlock(query);
    const skuBlock = linstanBuildSkuMatchBlock(query);
    if (!referenceBlock && !skuBlock) {
      return;
    }
    const emptyState = resultsSlotEl.querySelector(".empty-state");
    if (emptyState) {
      emptyState.remove();
    }
    if (skuBlock) {
      resultsSlotEl.insertBefore(skuBlock, resultsSlotEl.firstChild);
    }
    if (referenceBlock) {
      resultsSlotEl.insertBefore(referenceBlock, resultsSlotEl.firstChild);
    }
  }

  function linstanPatchPredictiveSearch() {
    const PredictiveSearchCtor = window.customElements.get("predictive-search");
    if (!PredictiveSearchCtor || PredictiveSearchCtor.prototype.__linstanReferencePatchApplied) {
      return;
    }
    ["_doPredictiveSearch", "_doFallbackSearch"].forEach((methodName) => {
      const original = PredictiveSearchCtor.prototype[methodName];
      if (typeof original !== "function") {
        return;
      }
      PredictiveSearchCtor.prototype[methodName] = async function (...args) {
        const result = await original.apply(this, args);
        try {
          linstanInjectReferenceMatch(this);
        } catch (error) {
          console.error("Linstan reference search injection failed", error);
        }
        return result;
      };
    });
    PredictiveSearchCtor.prototype.__linstanReferencePatchApplied = true;
  }

  linstanPatchPredictiveSearch();
})();